import { LoggerService } from '@wdpr/ra-angular-logger';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ConfigService } from '@finder/core/config.service';
import { CONFIG_CONSTANTS } from '@finder/shared/constants/app.constants';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import isEmpty from 'lodash-es/isEmpty';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/config.service";
import * as i2 from "../window-ref/window-ref.service";
import * as i3 from "@wdpr/ra-angular-logger";
const NEWSLETTER_SUBSCRIPTION_STATUS_COOKIE = 'newslettersSubscriptionStatus';
export class OneIdService {
    constructor(config, window, logger) {
        this.config = config;
        this.window = window;
        this.logger = logger;
        this.scriptLoaded = new BehaviorSubject(false);
        this.isLoaded = this.scriptLoaded.asObservable();
        this.oid = OneID.get({
            clientId: this.config.getValue(CONFIG_CONSTANTS.oneIdClientIdKey),
            responderPage: `${this.window.nativeWindow.location.origin}/advanced-finder/responder.html`,
            debug: this.config.getValue('environment') !== 'prod',
        });
        // Everything in this class is promises rather than observables because this constructor is
        // called via the app providers, which is promise-based. All these functions intertwine,
        // so it is simpler to leave them all as promises.
        this.oid.init()
            .then((data) => {
            this.logger.debug(`OneID initialized:`, data, this);
            this.scriptLoaded.next(true);
        })
            .catch(/* istanbul ignore next */ /* istanbul ignore next */ error => this.logger.error(`OneID init error:`, error));
    }
    getGuest() {
        return this.oid.getGuest();
    }
    getGuestNewsletters() {
        return this.oid.getGuestNewsletters();
    }
    optIn(email, campaignId, options = {}) {
        return this.getInlineNewsletters(campaignId, options)
            .then((response) => {
            const payload = this.buildInlineNewsletterRequest(campaignId, email, response);
            return this.setInlineNewsletters(payload, options);
        });
    }
    /* istanbul ignore next */
    on(event, listener) {
        this.oid.on(event, listener);
    }
    /* istanbul ignore next */
    off(event, listener) {
        this.oid.off(event, listener);
    }
    /**
     * Retrieves a list of configured newsletter campaigns; additionally, legal guidelines are provided if required.
     * This method returns a promise, that, when fulfilled, provides the integrator with data needed to render
     * a newsletter campaign to a user.
     */
    getInlineNewsletters(campaignId, options = {}, forceRefresh = false) {
        /* istanbul ignore if */
        if (!forceRefresh && this.newslettersCache) {
            return Promise.resolve(this.newslettersCache);
        }
        return this.oid.getInlineNewsletters(campaignId, options)
            .then((response) => {
            this.newslettersCache = response;
            return response;
        });
    }
    launchNewsletters(campaignId, options = {}) {
        // Make sure the options are formatted properly
        let optionalConfig;
        if (!isEmpty(options) && !options.optionalConfig) {
            optionalConfig = {
                optionalConfigs: {
                    reporting: options,
                }
            };
        }
        else {
            optionalConfig = options;
        }
        return this.oid.launchNewsletters(campaignId, optionalConfig);
    }
    getCookieKey(campaignId) {
        return `${NEWSLETTER_SUBSCRIPTION_STATUS_COOKIE}-${campaignId}`;
    }
    // tslint:disable-next-line: max-line-length
    buildInlineNewsletterRequest(campaignId, email, response) {
        const marketing = response.data.marketing.map((entry) => ({
            code: entry.code,
            subscribed: true
        }));
        const legal = response.data.legal.map((entry) => ({
            code: entry.code,
            accepted: true
        }));
        return {
            campaignId: campaignId,
            email,
            marketing,
            legal,
        };
    }
    setInlineNewsletters(data, options) {
        return this.oid.setInlineNewsletters(data, options);
    }
}
OneIdService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OneIdService_Factory() { return new OneIdService(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.WindowRef), i0.ɵɵinject(i3.LoggerService)); }, token: OneIdService, providedIn: "root" });
